import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import * as actions from './actions';
import * as api from './api';
import converter from './converter';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getCalculatorsPreceding.toString(),
            defaultSaga({
                constants: constants.getCalculatorsPreceding,
                api: api.getCalculatorsPreceding
            })
        ),
        yield takeLatest(
            constants.getCalculatorsPrecedingItem.toString(),
            defaultSaga({
                constants: constants.getCalculatorsPrecedingItem,
                api: api.getCalculatorsPrecedingItem
            })
        )
    ]);
}